module.exports = __webpack_public_path__ + "img/field_goal.f3b56687.jpg";